/* ========== GLOBAL SAFETY SHIMS & HELPERS ========== */
window.addToCart = function addToCart(/* item (unused) */) {
  try {
    const formEl = document.querySelector('product-form form');
    if (formEl) {
      console.log('global-form');
      formEl.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  } catch (e) {
    console.error('addToCart shim failed:', e);
  }
};


function showSpecificationsForVariant(variant) {
  const specEntries = document.querySelectorAll('.specifications-entry');
  if (!variant) {
    specEntries.forEach(entry => {
      const entrySize = entry.getAttribute('data-size')?.trim().toLowerCase();
      entry.style.display = entrySize ? 'none' : 'block';
    });
    return;
  }
  const sizeOption = variant.option2 || variant.option1;
  const normalized = sizeOption ? sizeOption.trim().toLowerCase() : null;
  specEntries.forEach(entry => {
    const entrySize = entry.getAttribute('data-size')?.trim().toLowerCase();

    if (!entrySize || entrySize === '') {
      entry.style.display = 'block';
    } else if (normalized && entrySize === normalized) {
      entry.style.display = 'block';
    } else {
      entry.style.display = 'none';
    }
  });
}



(function () {
  const seenInline = (window.__executedInlineScripts = window.__executedInlineScripts || new Set());
  const seenSrc     = (window.__executedSrcScripts    = window.__executedSrcScripts    || new Set());

  function hash(str) {
    let h = 0, i = 0, len = str.length;
    while (i < len) h = (h << 5) - h + str.charCodeAt(i++) | 0;
    return String(h);
  }

  window.executeScriptsFrom = function executeScriptsFrom(container) {
    if (!container) return;
    container.querySelectorAll('script').forEach((oldScript) => {
      const src = oldScript.getAttribute('src');
      if (src) {
        if (seenSrc.has(src)) return;
        seenSrc.add(src);
        const s = document.createElement('script');
        for (const { name, value } of Array.from(oldScript.attributes)) s.setAttribute(name, value);
        document.head.appendChild(s);
        return;
      }

      const code = oldScript.textContent || '';
      const sig = hash(code.trim());
      if (!code || seenInline.has(sig)) return;
      seenInline.add(sig);

      const s = document.createElement('script');
      s.text = `(function(){ try { ${code}\n } catch(e){ console.error('Inline script error:', e); } })();`;
      document.head.appendChild(s);
      document.head.removeChild(s);
    });
  };
})();

// 3) Idempotent “run once per node” helper
function onceOn(node, event, handler, options) {
  if (!node) return;
  const key = `__once_${event}`;
  if (node[key]) return;
  node.addEventListener(event, handler, options || false);
  node[key] = true;
}

// 4) Centralized re-init bundle (safe to call multiple times)
function runAllReinits(context) {
  try { initializeQuantitySelectors(context); } catch (e) { console.error('init qty failed', e); }
  try { initPopupScripts(context); } catch (e) { console.error('init popup failed', e); }
  try { bindUpsellButtonListeners(context); } catch (e) { /* optional */ }
}


/* ========== COMPONENTS ========== */

class ProductMediaSlider extends HTMLElement {
  constructor() { super(); this.init(); }
  init() {
    const splide = new Splide(".component--product--media__slider", {
      perPage: 1, pagination: true, arrows: true,
      padding: { left: 0, right: 0 }, gap: "0rem",
      breakpoints: { 768: { padding: { left: "0px", right: "0px" }, gap: "0rem" } }
    });

    const thumbnails = document.getElementsByClassName("component--product--media__thumbnail");
    let current;
    for (let i = 0; i < thumbnails.length; i++) {
      thumbnails[i].addEventListener("click", () => splide.go(i));
    }
    splide.on("mounted move", () => {
      const thumbnail = thumbnails[splide.index];
      if (!thumbnail) return;
      if (current) current.classList.remove("is-active");
      thumbnail.classList.add("is-active");
      current = thumbnail;
    });

        // 👇 Add your fallback hide logic here
    splide.on("mounted", function () {
      const fallback = document.querySelector(".product-media-fallback");
      if (fallback) fallback.style.display = "none";
    });
    splide.mount();
  }
}
customElements.define("product-media-slider", ProductMediaSlider);


class ProductForm extends HTMLElement {
  constructor() {
    super();

    // If this custom element is ever mounted inside the quickshop modal, bail out
    if (this.closest('#theme-quickshop-modal')) return;

    // Only pick forms that are NOT the quickshop form
    this.form = this.querySelector('form:not(.quick_shop_form)');
    this.cart = document.querySelector('cart-drawer');

    if (!this.form) return; // nothing to bind on PDP? just exit

    // Bind once
    this.onSubmitHandler = this.onSubmitHandler.bind(this);
    this.form.addEventListener('submit', this.onSubmitHandler);
  }

  attachProducts() {
    this.items = [];
    this.upsellElements = document.querySelectorAll(".component--product--upsell-main.selected");

    // Add selected upsell products
    this.upsellElements.forEach((upsell) => {
      const addOnId = upsell.getAttribute("data-add-on-id");
      if (addOnId) {
        this.items.push({
          id: parseInt(addOnId, 10),
          quantity: parseInt(upsell.getAttribute("data-add-on-qty") || "1", 10),
        });
      }
    });

    // Add main product
    const formData = JSON.parse(serializeForm(this.form));
    let item = null;
    if (formData.selling_plan == undefined) {
      item = { id: formData.id, quantity: formData.quantity };
    } else {
      // window.number is set inside variant render; fallback to quantity if missing
      const qty = (typeof window.number !== 'undefined' && window.number) ? window.number : formData.quantity;
      item = { id: formData.id, quantity: qty, selling_plan: formData.selling_plan };
    }
    this.items.push(item);
  }

  async onSubmitHandler(evt) {
    try {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      submitButton.classList.add("adding_product");
      submitButton.setAttribute("disabled", true);
      console.log('main pdp form');
      this.attachProducts();
      const newItems = this.items;

      const cart = await fetch("/cart.js", { method: "GET" }).then(r => r.json());
      const updatedItems = [];

      newItems.forEach((newItem) => {
        const existingItem = cart.items.find(
          (item) =>
            item.variant_id === newItem.id &&
            (!item.selling_plan || item.selling_plan === newItem.selling_plan)
        );

        if (existingItem) {
          updatedItems.push({ id: existingItem.id, quantity: newItem.quantity });
        } else {
          updatedItems.push({ id: newItem.id, quantity: newItem.quantity, selling_plan: newItem.selling_plan || null });
        }
      });

      const body = JSON.stringify({
        updates: updatedItems.reduce((acc, item) => { acc[item.id] = item.quantity; return acc; }, {})
      });

      const upd = await fetch("/cart/update.js", { ...fetchConfig("javascript"), body });
      await upd.json();

      const state = await fetch("/?section_id=global--cart-drawer").then(r => r.text());
      this.cart.renderContents(state);
      submitButton.classList.remove("adding_product");
    } catch (e) {
      console.error(e);
    } finally {
      const submitButton = this.querySelector('[type="submit"]');
      submitButton?.removeAttribute("disabled");
    }
  }
}
customElements.define("product-form", ProductForm);


class ProductUpsellAddOn extends HTMLElement {
  constructor() {
    super();
    this.cart = document.querySelector("cart-drawer");
    this.addEventListener("click", (event) => {
      const button = event.target.closest('.component--product--upsell-add');
      if (!button) return;
      button.classList.add("adding_product");
      this.onAddToCartClick(event, button);
    });
  }

  onAddToCartClick(event, button) {
    const upsellMarkup = event.target.closest('.component--product--upsell');
    const addOnId = upsellMarkup.getAttribute('data-add-on-id');
    const newQuantity = parseInt(upsellMarkup.getAttribute('data-add-on-qty'), 10) || 1;

    const submitButton = event.target;
    submitButton.setAttribute("disabled", true);

    fetch("/cart.js", { method: "GET" })
      .then(response => response.json())
      .then(cart => {
        const updatedItems = [];
        const existingItem = cart.items.find(item => item.variant_id == addOnId);

        if (existingItem) {
          updatedItems.push({ id: existingItem.id, quantity: newQuantity });
        } else {
          updatedItems.push({ id: addOnId, quantity: newQuantity });
        }

        const body = JSON.stringify({
          updates: updatedItems.reduce((acc, item) => { acc[item.id] = item.quantity; return acc; }, {}),
        });

        return fetch("/cart/update.js", { ...fetchConfig("javascript"), body });
      })
      .then(response => {
        button.classList.remove("adding_product");
        if (!response.ok) throw new Error("Failed to update cart");
        return fetch(`/?section_id=global--cart-drawer`);
      })
      .then(response => response.text())
      .then(state => { this.cart.renderContents(state); })
      .catch(error => { console.error("Error updating cart:", error); })
      .finally(() => { submitButton.removeAttribute("disabled"); });
  }
}
customElements.define("product-upsell-add-on", ProductUpsellAddOn);


class ProductStickyBar extends HTMLElement {
  constructor() {
    super();
    this.buybox = document.querySelector(".component--product-form");
    this.bar = this.querySelector(".component--product--sticky-bar");
    this.productForm = document.querySelector("product-form");
    this.cart = document.querySelector("cart-drawer");
    this.lastScrollTop = 0;
    this.bindEvents();
    this.toggle.bind(this);
  }

  bindEvents() {
    document.addEventListener("scroll", this.toggle.bind(this));
    const btn = this.querySelector(".component--product--sticky-bar__button");
    onceOn(btn, "click", (event) => {
      const submitButton = this.productForm.querySelector('[type="submit"]');
      submitButton?.setAttribute("disabled", true);
      const form = this.productForm.querySelector("form");
      form?.dispatchEvent(new Event("submit"));
    });
  }

toggle() {
  const mediaQuery = window.matchMedia("(min-width: 768px)");
  const bar = document.querySelector(".component--product--sticky-bar");
  const footer = document.querySelector("footer");
  const chartSection = document.querySelector(".nothing--pdp--chat--table");
  if (!bar || !footer) return;

  const isPastTrigger = !this.checkVisibilityOfElements([
    "product-media-slider",
    "product-form",
  ]);

  const footerRect = footer.getBoundingClientRect();
  const windowHeight = window.innerHeight;
  const isFooterVisible = footerRect.top <= windowHeight;

  let isChartVisible = false;
  if (chartSection) {
    const rect = chartSection.getBoundingClientRect();
    isChartVisible = rect.top < windowHeight && rect.bottom > 0;
  }

  // ✅ Base active logic
  if (isPastTrigger && !isFooterVisible) {
    bar.classList.add("component--product--sticky-bar--active");
  } else {
    bar.classList.remove("component--product--sticky-bar--active");
  }

  // ✅ Scroll direction logic
  const currentScroll = window.scrollY || window.pageYOffset;
  const scrollDown = currentScroll > this.lastScrollTop;

  if (isPastTrigger && !isFooterVisible) {
    if (scrollDown) {
      bar.classList.remove("component--product--sticky-bar--scroll-active");
    } else {
      bar.classList.add("component--product--sticky-bar--scroll-active");
    }
  } else {
    bar.classList.remove("component--product--sticky-bar--scroll-active");
  }

  // ✅ Remove active class if chart visible on desktop
  if (mediaQuery.matches && isChartVisible) {
    bar.classList.remove("component--product--sticky-bar--active");
  }

  this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
}



  checkVisibilityOfElements(elementIds) {
    return elementIds.some((sel) => {
      const element = document.querySelector(sel);
      if (!element) return false;
      const rect = element.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0;
    });
  }
}
customElements.define("product-sticky-bar", ProductStickyBar);


class ProductFAQ extends HTMLElement {
  constructor() { super(); this.accordions = document.querySelectorAll(".component--product--faq--question"); this.bindEvents(); }
  bindEvents() { this.accordions.forEach((a) => a.addEventListener("click", this.toggleAccordion.bind(this))); }
  toggleAccordion(event) {
    const element = event.currentTarget;
    element.classList.toggle("component--product--faq--question--active");
    this.accordions.forEach((accordion) => {
      if (accordion !== element) accordion.classList.remove("component--product--faq--question--active");
    });
  }
}
customElements.define("product-faq", ProductFAQ);


// class ProductDropdown extends HTMLElement {
//   constructor() { super(); this.accordion = this.querySelector(".component--product--dropdown__titles"); this.bindEvents(); }
//   bindEvents() { this.accordion.addEventListener("click", this.toggleAccordion.bind(this)); }
//   toggleAccordion(event) {
//     const element = event.currentTarget;
//     element.classList.toggle("component--product--dropdown__titles--active");
//   }
// }
// customElements.define("product-dropdown", ProductDropdown);



class PublicationSlider extends HTMLElement {
  constructor() { super(); this.init(); }
  init() {
    const splide = new Splide(".page--product--publications__slider", {
      pagination: false, arrows: false, autoplay: true,
      breakpoints: { 768: { pagination: true } },
    });

    const thumbnails = document.getElementsByClassName("page--product--publications__thumbnail");
    let current;
    for (let i = 0; i < thumbnails.length; i++) {
      thumbnails[i].addEventListener("click", () => splide.go(i));
    }
    splide.on("mounted move", () => {
      const thumbnail = thumbnails[splide.index];
      if (!thumbnail) return;
      if (current) current.classList.remove("is-active");
      thumbnail.classList.add("is-active");
      current = thumbnail;
    });
    splide.mount();
  }
}
customElements.define("publication-slider", PublicationSlider);


class SubscriptionSelector extends HTMLElement {
  constructor() {
    super();
    this.onetime = document.querySelector('[data-product-type="onetime"]');
    this.subscription = document.querySelector('[data-product-type="subscription"]');
    this.isSubscription = false;
    this.bindEvents();
    this.init();
  }
  bindEvents() {
    this.onetime?.addEventListener("click", this.selectOneTime.bind(this));
    this.subscription?.addEventListener("click", this.selectSubscription.bind(this));
  }
  init() {
    if (this.getParameterByName("subscription") !== null) this.selectSubscription();
    else this.selectOneTime();
  }
  getSubscriptionData() {
    this.subscriptionData = this.subscriptionData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.subscriptionData;
  }
  getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, "\\$&");
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
  showSubscription() {
    document.querySelector('[data-product-type="onetime"]')
      ?.classList.remove("component--product--subscription-selector__option--active");
    document.querySelector('[data-product-type="subscription"]')
      ?.classList.add("component--product--subscription-selector__option--active");
  }
  hideSubscription() {
    document.querySelector('[data-product-type="onetime"]')
      ?.classList.add("component--product--subscription-selector__option--active");
    document.querySelector('[data-product-type="subscription"]')
      ?.classList.remove("component--product--subscription-selector__option--active");
  }
  selectOneTime() { this.isSubscription = false; this.hideSubscription(); this.toggleInfo(false); this.removeInput(); }
  selectSubscription() {
    this.isSubscription = true;
    this.getSubscriptionData();
    this.sellingPlan = this.subscriptionData[0].selling_plans[0].id;
    this.showSubscription();
    this.createInput(this.sellingPlan);
    this.toggleInfo(true);
  }
  createInput(sellingPlanId) {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-bar`);
    productForms.forEach((productForm) => {
      const existing = productForm.querySelector('input[name="selling_plan"]');
      if (existing) existing.setAttribute("value", sellingPlanId);
      else {
        const input = document.createElement("input");
        input.type = "hidden"; input.setAttribute("name", "selling_plan"); input.setAttribute("value", sellingPlanId);
        productForm.appendChild(input);
      }
    });
  }
  removeInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-bar`);
    productForms.forEach((productForm) => {
      const ele = productForm.querySelector('input[name="selling_plan"]');
      if (ele) ele.parentNode.removeChild(ele);
    });
  }
  toggleInfo(check = false) {
    const info = document.querySelector(".component--product--subscription-selector__info");
    if (!info) return;
    if (check) info.classList.add("component--product--subscription-selector__info--active");
    else info.classList.remove("component--product--subscription-selector__info--active");
  }
}
customElements.define("subscription-selector", SubscriptionSelector);


class ProductUpsell extends HTMLElement {
  constructor() {
    super();
    this.lineItems = [];
    this.upsells = document.querySelectorAll(".component--product--upsell");
    this.selectedValue = document.querySelector(".component--product--upsell__select-value");
    this.onClick.bind(this);
    this.bindEvents();
    this.handleClickOutside = this.handleClickOutside.bind(this);
    document.addEventListener("click", this.handleClickOutside);
  }
  bindEvents() {
    this.upsells.forEach((upsell) => {
      upsell.querySelector(".component--product--upsell__image-wrapper")
        ?.addEventListener("click", this.onClick.bind(this));
    });
    const customSelect = document.querySelector(".component--product--upsell__select");
    const selectBtn = document.querySelector(".component--product--upsell__select-button");
    const selectDropdown = document.querySelector(".component--product--upsell__select-dropdown");
    selectBtn?.addEventListener("click", () => {
      customSelect?.classList.toggle("component--product--upsell__select--active");
      selectDropdown?.classList.toggle("component--product--upsell__select-dropdown--active");
      selectBtn.setAttribute("aria-expanded",
        selectBtn.getAttribute("aria-expanded") === "true" ? "false" : "true");
    });
    selectDropdown?.querySelectorAll("input").forEach((option) => {
      option.addEventListener("change", this.onVariantChange.bind(this));
    });
  }
  handleClickOutside(event) {
    const customSelect = document.querySelector(".component--product--upsell__select");
    const selectDropdown = document.querySelector(".component--product--upsell__select-dropdown");
    if (!customSelect) return;
    if (!customSelect.contains(event.target) &&
      customSelect.classList.contains("component--product--upsell__select--active")) {
      customSelect.classList.remove("component--product--upsell__select--active");
      selectDropdown?.classList.remove("component--product--upsell__select-dropdown--active");
      document.querySelector(".component--product--upsell__select-button")
        ?.setAttribute("aria-expanded", "false");
    }
  }
  onClick(event) {
    const ele = event.currentTarget;
    const id = this.getAttribute("data-add-on-id");
    const isExist = this.lineItems.filter((item) => id == item.id).length > 0;
    if (!isExist) { this.attachProduct(event); this.updateCheckbox(true, ele); }
    else { this.deattachProduct(event); this.updateCheckbox(false, ele); }
  }
  updateCheckbox(check) {
    const box = document.querySelector(".component--product--upsell__checkbox");
    if (!box) return;
    if (check) box.classList.add("component--product--upsell__checkbox--active");
    else box.classList.remove("component--product--upsell__checkbox--active");
  }
  attachProduct() {
    const id = this.getAttribute("data-add-on-id");
    const qty = this.getAttribute("data-add-on-qty");
    this.lineItems = [{ id, quantity: qty }];
  }
  deattachProduct() {
    const id = this.getAttribute("data-add-on-id");
    this.lineItems = this.lineItems.filter((item) => id != item.id);
  }
  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
      console.log('quantity update now');
    const customSelect = document.querySelector(".component--product--upsell__select");
    const selectedValue = document.querySelector(".component--product--upsell__select-value");
    if (selectedValue && this.currentVariant) selectedValue.textContent = this.currentVariant.title;
    customSelect?.classList.remove("component--product--upsell__select--active");

    const currency = document.querySelector(".component--product--upsell__prices")?.getAttribute("data-iso-code") || '';
    if (this.currentVariant) {
      const units = parseInt(this.currentVariant.option1.split(' ')[0], 10) || 1000;
      const priceDollars = (this.currentVariant.price / 100) * (units / 1000);
      const formattedPrice = priceDollars.toString()
        .replace(/\.00$/, "")
        .replace(/(\.\d*[1-9])0+$/, "$1");
      const priceNode = document.querySelector(".component--product--upsell__price");
      if (priceNode) priceNode.textContent = `$${formattedPrice} ${currency}`;
    }

    const comparePrice = e?.currentTarget?.getAttribute("data-compare-price");
    const compareNode = document.querySelector(".component--product--upsell__compare-price");
    if (comparePrice && compareNode) {
      const comparePriceDollars = (comparePrice / 100).toString()
        .replace(/\.00$/, "")
        .replace(/(\.\d*[1-9])0+$/, "$1");
      compareNode.textContent = `$${comparePriceDollars}`;
    }

    if (this.currentVariant) {
      const qty = parseInt(this.currentVariant.title.split(' ')[0], 10) / 1000 || 1;
      document.querySelector(".component--product--upsell")
        ?.setAttribute("data-add-on-id", this.currentVariant.id);
      document.querySelector(".component--product--upsell")
        ?.setAttribute("data-add-on-qty", qty);
    }

    document.querySelector(".component--product--upsell__select-dropdown")
      ?.classList.remove("component--product--upsell__select-dropdown--active");

    const id = this.getAttribute("data-add-on-id");
    const isExist = this.lineItems.filter((item) => id == item.id).length > 0;
    if (!isExist) { this.attachProduct(); this.updateCheckbox(true); }
    else { this.deattachProduct(); this.updateCheckbox(false); }
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => this.options[index] === option).includes(false);
    });
  }
  getVariantData() {
    this.variantData = this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) =>
      Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked)?.value
    );
  }
}
customElements.define("product-upsell", ProductUpsell);


class ProductBulk extends HTMLElement {
  constructor() {
    super();
    this.productForm = document.querySelector("product-form");
    this.bulkForm = document.querySelector("product-bulk-form");
    this.subscriptionSelector = document.querySelector("subscription-selector");
    this.upsell = document.querySelector("product-upsell");
    this.bindEvents();
  }
  bindEvents() {
    function gtag_report_conversion(url) {
      const callback = function () { if (typeof url != "undefined") window.location = url; };
      window.gtag && gtag("event", "conversion", {
        send_to: "AW-700354441/wpQ-COis76MYEImf-s0C", event_callback: callback,
      });
      return false;
    }
    document.querySelectorAll("[data-bulk-form-button], .open--typeform--drawer").forEach((button) => {
      if (!button.dataset.typeformBound) {
        button.dataset.typeformBound = "true";

        button.addEventListener("click", (e) => {
          e.preventDefault();

          // Optional: only fire if Typeform is ready
          if (window.tf && typeof window.tf.createSlider === "function") {
            gtag_report_conversion();
            const { toggle } = window.tf.createSlider("gaQipKwE", {
              transitiveSearchParams: true
            });
            toggle();
          } else {
            console.warn("Typeform not loaded yet.");
          }
        });
      }
    });
  }
  showBulk() {
    this.productForm.style.display = "none";
    this.subscriptionSelector.style.display = "none";
    if (this.upsell) this.upsell.style.display = "none";
    document.querySelector(".component--product--sticky-bar__buttons").style.display = "none";
    document.querySelector(".component--product--sticky-bar__bulk-button").style.display = "inline-block";
    this.bulkForm.style.display = "block";
    this.classList.add("component--product--case-selector__bulk--active");
    document.querySelectorAll(".component--product--case-selector__options-box input").forEach((input) => {
      input.checked = false;
    });
  }
}
customElements.define("product-bulk", ProductBulk);


class ProductBulkBox extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
  }
  bindEvents() {
    function gtag_report_conversion(url) {
      var callback = function () {
        if (typeof url != "undefined") {
          window.location = url;
        }
      };
      gtag("event", "conversion", {
        send_to: "AW-700354441/wpQ-COis76MYEImf-s0C",
        event_callback: callback,
      });
      return false;
    }
    document.querySelectorAll("[data-bulk-box-button]").forEach((button) => {
      button.addEventListener("click", () => {
        gtag_report_conversion();
        const { toggle } = window.tf.createSlider("PSGGS5LX", {
          transitiveSearchParams: true,
        });
        toggle();
      });
    });
  }
}
customElements.define("product-bulk-box", ProductBulkBox);



class SampleVariantSelector extends HTMLElement {
  constructor() {
    super();
    this.cart = document.querySelector("cart-drawer");
    this.subscriptionSelector = document.querySelector("subscription-selector");
    this.productFormBar = document.querySelector("product-form-bar");
    this.addEventListener("change", this.onVariantChange.bind(this));

    const seeMore = document.querySelector("[data-see-more]");
    if (seeMore) {
      this.seeMore = false;
      seeMore.addEventListener("click", this.toggleBox.bind(this, seeMore));
      this.bindSelector();
    }
  }

  updateSavingPrice() {
    function removeCents(price) {
      price = price.replace("$", "").replace(/,/g, "");
      price = parseFloat(price);
      let roundedPrice = Math.floor(price);
      return `$${roundedPrice.toLocaleString()}`;
    }
    document.querySelectorAll("[data-discount-amount]").forEach((el) => {
      const price = el.getAttribute("data-discount-amount");
      if (!price) return;
      const formattedprice = removeCents(price);
      el.innerHTML = `Save ${formattedprice}`;
    });
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    const changedOptionName = e.target.getAttribute("data-option-name");
    if (!this.currentVariant) {
      this.options.pop();
      this.currentVariants = this.getVariantData().filter((variant) =>
        this.options.every((option, index) => variant.options[index] === option)
      );
      this.currentVariant = this.currentVariants[0];
    }
    if (this.options.length > 1 && changedOptionName != "case") {
      this.options.pop();
      this.currentVariants = this.getVariantData().filter((variant) =>
        this.options.every((option, index) => variant.options[index] === option)
      );
      this.currentVariant = this.currentVariants[0];
    }
    window.location.href = `${this.dataset.url}?variant=${this.currentVariant.id}`;
  }

  toggleBox(seeMore) {
    const box = document.querySelector(".component--product--sample-variant-case-selector__options-box");
    const labels = box?.querySelectorAll("label") || [];
    box?.classList.toggle("component--product--sample-variant-case-selector__options-box--hidden");
    document.querySelector(".component--product--sample-variant-case-selector__see-more")
      ?.classList.toggle("component--product--sample-variant-case-selector__see-more--active");
    if (box?.classList.contains("component--product--sample-variant-case-selector__options-box--hidden")) {
      if (labels.length >= 5) {
        box.style.height =
          labels[0].clientHeight + labels[1].clientHeight + labels[2].clientHeight + labels[3].clientHeight + labels[4].clientHeight + "px";
      }
      document.querySelector(".page--product--product__container")
        ?.setAttribute("data-see-more-clicked", "false");
    } else {
      box.style.height = box.scrollHeight + "px";
      seeMore.style.display = "none";
      const bulkBorderTop = document.querySelector(".component--product--sample-variant-case-selector__bulk--border-top");
      if (bulkBorderTop) bulkBorderTop.style.opacity = "0.5";
      document.querySelector(".page--product--product__container")
        ?.setAttribute("data-see-more-clicked", "true");
    }
  }

  bindSelector() {
    const box = document.querySelector(".component--product--sample-variant-case-selector__options-box");
    const radios = box?.querySelectorAll('input[type="radio"]') || [];
    const seeMore = document.querySelector("[data-see-more]");
    let isChecked = false;
    if (radios.length > 5) {
      for (let i = 5; i < radios.length; i++) { if (radios[i].checked) { isChecked = true; break; } }
      const isOpen = JSON.parse(
        document.querySelector(".page--product--product__container")
          ?.getAttribute("data-see-more-clicked") || "false"
      );
      if (isOpen || isChecked) {
        box.classList.remove("component--product--sample-variant-case-selector__options-box--hidden");
        box.style.height = "auto";
        if (seeMore) seeMore.style.display = "none";
        const bulkBorderTop = document.querySelector(".component--product--sample-variant-case-selector__bulk--border-top");
        if (bulkBorderTop) bulkBorderTop.style.opacity = "0.5";
      } else {
        const labels = box.querySelectorAll("label");
        if (labels.length > 5) {
          box.style.height =
            labels[0].clientHeight + labels[1].clientHeight + labels[2].clientHeight + labels[3].clientHeight + labels[4].clientHeight + "px";
        }
      }
      this.updateSavingPrice();
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => this.options[index] === option)
        .includes(false);
    });
  }
  getVariantData() {
    this.variantData = this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) =>
      Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked)?.value
    );
  }
}
customElements.define("sample-variant-selector", SampleVariantSelector);


/* ========== UTILITIES YOU CALL DIRECTLY OR VIA runAllReinits ========== */

function initializeQuantitySelectors(context) {
  console.log('initialize check');
  const root = context || document;
  const quantitySelectors = root.querySelectorAll('.quantity-selector');
  const main_price = document.querySelector('.component--product--price__sale');
  const main_price_full = document.querySelector('.component--product--price__base');
  const main_price_discount = document.querySelector('.component--product--price__discount');
  const main_total_pieces = document.querySelector('.componnent_per_piece_price_total-pieces');
  const main_per_piece = document.querySelector('.componnent_per_piece_price_sigle-piece-price');
  const sticky_pieces = document.querySelector('.bottom_sticky_bar_pcs');
  const bulk_buy_component = document.querySelector('.component--product--case-selector__bulk');

  quantitySelectors.forEach((selector) => {
    const decreaseBtn = selector.querySelector('.quantity-decrease');
    const increaseBtn = selector.querySelector('.quantity-increase');
    const input = selector.querySelector('.quantity-input');
    if (!decreaseBtn || !increaseBtn || !input) return;

    const quantity_cases_label = selector.querySelector('.quantity_cases_label');
    const quantity_original_price = selector.querySelector('.quantity_original_price');
    const quantity_compare_price = selector.querySelector('.quantity_compare_price');
    const org_per_pice = parseFloat(quantity_original_price?.getAttribute('data-price') || "0");
    const pieces_selector = selector.querySelector('.quantity_span_total_pieces');
    const pieces_quantity = parseInt(pieces_selector?.getAttribute('data-pieces') || "1", 10);
    const per_piece_selector = selector.querySelector('.quantity_span_per_piece');
    const per_piece_selector_type = per_piece_selector?.getAttribute('data-type') || 'piece';
    const quantity_savings = selector.querySelector('.quantity_savings');
    // let countryCode = window.Shopify?.currency?.active || 'USD';
    const countryInputs = document.getElementsByName('country_code');
    let countryCode = '';
    if (countryInputs.length > 0) {
      if(countryInputs[0].value == 'US'){
        countryCode = 'USD';
      }
      else if(countryInputs[0].value == 'CA'){
        countryCode = 'CAD';
      }else{
        countryCode = '';
      }
      console.log('countryCode',countryCode);
    }

const updateQuantity = (change) => {
  const currentValue = parseInt(input.value, 10) || 0;
  const min = parseInt(input.min, 10) || 0;
  const max = parseInt(input.max, 10) || Infinity;
  const newValue = Math.max(min, Math.min(max, currentValue + change));

  const qunatity_base_price = (newValue * org_per_pice).toFixed(2);
  const total_pieces_quantity = newValue * pieces_quantity;

  const stickyPriceEl = document.querySelector('.component--product--sticky-bar__price');
  const stickyCompareEl = document.querySelector('.component--product--sticky-bar__compare-at-price');
  const stickySaveEl = document.querySelector('.component--product--sticky-bar__save-price');

  let discountPercentage = 0;
  if (newValue >= 3 && newValue <= 5) discountPercentage = 5;
  else if (newValue >= 6 && newValue <= 8) discountPercentage = 7;
  else if (newValue === 9) discountPercentage = 9;
  else if (newValue >= 10) discountPercentage = 10;

  if (bulk_buy_component) {
    if (newValue > 9) bulk_buy_component.classList.remove("component--product--case-selector__bulk_hide");
    else bulk_buy_component.classList.add("component--product--case-selector__bulk_hide");
  }

  const discountAmount = (qunatity_base_price * discountPercentage) / 100;
  const discountedPrice = (qunatity_base_price - discountAmount).toFixed(2);
  const per_piece_price = (Math.floor((discountedPrice / total_pieces_quantity) * 1000) / 1000).toFixed(3);

  input.value = newValue;
  const quantityInputForm = document.querySelector('.component--product--form__wrapper input[name="quantity"]');
  if (quantityInputForm) quantityInputForm.value = newValue;
  

  if (quantity_cases_label) quantity_cases_label.textContent = newValue < 2 ? `${newValue} Case` : `${newValue} Cases`;

  const basePriceParsed = parseFloat(qunatity_base_price);
  const discountedPriceParsed = parseFloat(discountedPrice);
  const discountTrue = (basePriceParsed * 100) > (discountedPriceParsed * 100);

  if (discountTrue && newValue > 1) {
    if (quantity_compare_price) {
      quantity_compare_price.style.display = 'inline';
      quantity_compare_price.textContent = '$' + Math.round(qunatity_base_price).toLocaleString('en-US');
    }
    if (main_price_full) main_price_full.textContent = '$' + Math.round(qunatity_base_price).toLocaleString('en-US');
    if (quantity_savings) quantity_savings.textContent = 'Save $' + Math.round(discountAmount).toLocaleString('en-US') + ' (' + discountPercentage + '%)';
    if (main_price_discount) main_price_discount.textContent = 'Save $' + Math.round(discountAmount).toLocaleString('en-US') + ' (' + discountPercentage + '%)';
  } else {
    if (quantity_compare_price) {
      quantity_compare_price.style.display = 'none';
      quantity_compare_price.textContent = '';
    }
    if (main_price_full) main_price_full.textContent = '';
    if (quantity_savings) quantity_savings.textContent = '';
    if (main_price_discount) main_price_discount.textContent = '';
  }

  if (quantity_original_price) {
  quantity_original_price.textContent =
    '$' + Number(discountedPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
    ' ' + countryCode;
}
  if (main_price) main_price.textContent = '$' + Number(discountedPrice).toLocaleString('en-US') + ' ' + countryCode;

  if (pieces_selector) pieces_selector.textContent = total_pieces_quantity.toLocaleString('en-US') + ' PCS';
  if (main_total_pieces) main_total_pieces.textContent = total_pieces_quantity.toLocaleString('en-US') + ' PCS';
  if (!selector.closest('.qsm-quickshop-modal')) {
  if (sticky_pieces) sticky_pieces.textContent = total_pieces_quantity.toLocaleString('en-US') + ' PCS';
}

  if (per_piece_selector) per_piece_selector.textContent = ' / ' + per_piece_price + ' per ' + per_piece_selector_type;
  if (main_per_piece) main_per_piece.textContent = per_piece_price + '/' + per_piece_selector_type;

// ✅ Sticky bar prices
if (stickyPriceEl) {
  stickyPriceEl.textContent =
    '$' + Number(discountedPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
    ' ' + countryCode;
}


  if (stickyCompareEl) {
    if (discountPercentage > 0 && newValue > 1) {
      stickyCompareEl.style.display = 'inline';
      stickyCompareEl.textContent = '$' + Math.round(qunatity_base_price).toLocaleString('en-US');
    } else {
      stickyCompareEl.style.display = 'none';
      stickyCompareEl.textContent = '';
    }
  }

  if (stickySaveEl) {
    if (discountPercentage > 0 && newValue > 1) {
      stickySaveEl.style.display = 'inline';
      stickySaveEl.textContent = `Save $${Math.round(discountAmount).toLocaleString('en-US')} (${discountPercentage}%)`;
    } else {
      stickySaveEl.style.display = 'none';
      stickySaveEl.textContent = '';
    }
  }
  

  toggleButtonState();
};


    const toggleButtonState = () => {
      const currentValue = parseInt(input.value, 10) || 0;
      decreaseBtn.disabled = currentValue <= (parseInt(input.min, 10) || 0);
      increaseBtn.disabled = currentValue >= (parseInt(input.max, 10) || Infinity);
    };

    // Ensure we don't attach duplicate listeners
    onceOn(decreaseBtn, 'click', () => updateQuantity(-1));
    onceOn(increaseBtn, 'click', () => updateQuantity(1));
    onceOn(input, 'input', () => {
      const value = Math.max(input.min || 0, Math.min(input.max || Infinity, parseInt(input.value, 10) || 0));
      input.value = value;
      toggleButtonState();
    });

    toggleButtonState();
  });
}

function initPopupScripts(context) {
  const root = context || document;
  const popup = root.getElementById
    ? root.getElementById("mcmsSaveMorePopup")
    : document.getElementById("mcmsSaveMorePopup");
  if (!popup) return;

  const overlay = document.querySelector(".mcms-popup-overlay");
  const openPopupBtns = document.querySelectorAll("#mcmsOpenPopup");
  const closePopupBtn = popup.querySelector(".mcms-popup-close");

  let popupScrollPosition = 0;

  function lockScroll() {
    popupScrollPosition = window.pageYOffset;

    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    document.body.style.position = 'fixed';
    document.body.style.top = `-${popupScrollPosition}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    
    // 👇 Add scrollbar compensation (just like cart drawer)
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }
  }

  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    document.body.style.paddingRight = ''; // 👈 Remove padding compensation

    window.scrollTo(0, popupScrollPosition);
  }

  function openPopup(e) {
    e?.preventDefault();

    if (window.innerWidth > 768) popup.classList.add("mcms-fade-in");
    else popup.classList.add("mcms-slide-up");

    popup.classList.remove("mcms-hidden");
    overlay.classList.add("mcms-visible");
    lockScroll();
  }

  function closePopup() {
    if (window.innerWidth > 768) {
      popup.classList.add("mcms-hidden");
      popup.classList.remove("mcms-fade-in");
    } else {
      popup.classList.add("mcms-slide-down");
      setTimeout(() => {
        popup.classList.add("mcms-hidden");
        popup.classList.remove("mcms-slide-up", "mcms-slide-down");
      }, 300);
    }

    overlay.classList.remove("mcms-visible");
    unlockScroll();
  }

  openPopupBtns.forEach(btn => {
    onceOn(btn, "click", openPopup);
  });

  if (closePopupBtn) onceOn(closePopupBtn, "click", closePopup);
  if (overlay) onceOn(overlay, "click", closePopup);
}



// Upsell “select” buttons safe binder
function bindUpsellButtonListeners(context) {
  const root = context || document;
  const buttons = root.querySelectorAll?.('.component--product--upsell__select-button') ||
                  document.querySelectorAll('.component--product--upsell__select-button');
  buttons.forEach(button => {
    if (!button._listenerAttached) {
      button.addEventListener('click', () => {
        const select = document.querySelector('.component--product--upsell__select');
        const dropdown = document.querySelector('.component--product--upsell__select-dropdown');
        select?.classList.toggle('component--product--upsell__select--active');
        dropdown?.classList.toggle('component--product--upsell__select-dropdown--active');
      });
      button._listenerAttached = true;
    }
  });
}


/* ========== BOOT ========== */

document.addEventListener('DOMContentLoaded', () => {
  // initial page init
  runAllReinits(document);

  if (!window.__splideStrawInit) window.__splideStrawInit = true;
});



// ---------- SAFE VARIANT HANDLER (no HTML/script re-injection) ----------
(() => {
  const SELECTOR = 'variant-radios';

  // Guard against double registration if your file can be evaluated more than once
  if (window.__VariantRadiosRegistered__) return;
  window.__VariantRadiosRegistered__ = true;

  class VariantRadios extends HTMLElement {
  connectedCallback() {
    this.form = document.querySelector(`form#product-form-${this.dataset.section}`) ||
                document.querySelector(`[id^="product-form-"]`);
    this.idInput = this.form?.querySelector('input[name="id"]');
    this.qtyInput = this.form?.querySelector('input[name="quantity"]');

    this.priceSaleEl   = document.querySelector('.component--product--price__sale');
    this.priceBaseEl   = document.querySelector('.component--product--price__base');
    this.discountEl    = document.querySelector('.component--product--price__discount');
    this.stickyPriceEl = document.querySelector('.component--product--sticky-bar__price, .component--product--sticky-bar__prices .component--product--sticky-bar__price');
    this.stickyOptsBox = document.querySelector('.component--product--sticky-bar--options-wrapper');
    this.optionTitleEls = this.querySelectorAll('.component--product--variant-selector__title-selected-option');

    // ✅ Yeh dono lines yahan add karo
    this.productUrl = this.dataset.url;
    this.sectionId  = this.dataset.section;

    this.variantData = this._readVariantJSON();
    if (!this.variantData || !this.variantData.length) {
      console.warn('[VariantRadios] No variants JSON found under this element.');
      return;
    }

    this._setOptionsFromInputs();
    this._bindRadioChanges();
    this._onOptionsChanged();

    // ✅ Handle initial selected variant specs
const initialVariant = this._findVariant();
showSpecificationsForVariant(initialVariant);
  }

    _readVariantJSON() {
      try {
        const jsonEl = this.querySelector('script[type="application/json"]');
        return jsonEl ? JSON.parse(jsonEl.textContent) : null;
      } catch (e) {
        console.error('[VariantRadios] Bad JSON:', e);
        return null;
      }
    }

    _bindRadioChanges() {
      const radios = this.querySelectorAll('.component--product--variant-radio__input');
      radios.forEach(radio => {
        radio.addEventListener('change', () => {
          this._setOptionsFromInputs();
          this._onOptionsChanged();
        });
      });
    }

    _setOptionsFromInputs() {
      // Build options array ordered by option1/2/3 using fieldsets order
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map(set => {
        const checked = set.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    _findVariant() {
      if (!this.options || !this.options.length) return null;
      return this.variantData.find(v => {
        const opts = [v.option1, v.option2, v.option3].filter(Boolean);
        if (opts.length !== this.options.length) return false;
        for (let i = 0; i < opts.length; i++) {
          if (opts[i] !== this.options[i]) return false;
        }
        return true;
      }) || null;
    }

_onOptionsChanged() {
  const variant = this._findVariant(); // 👈 Pehle define karo
    if (this.closest('.qsm-quickshop-modal')) return;
const isQuickDrawer = this.closest('.qsm-quickshop-modal');
if (isQuickDrawer) {
  const variant = this._findVariant();
  if (!variant) return;

  const productUrl =
    this.productUrl ||
    isQuickDrawer.querySelector('variant-radios')?.dataset.url ||
    window.location.pathname;

  const sectionId =
    this.sectionId ||
    isQuickDrawer.querySelector('variant-radios')?.dataset.section ||
    'product-template';

  const url = `${productUrl}?variant=${variant.id}&section_id=${sectionId}`;

  // ✅ Save current quantity before replacing box
  const currentQtyInput = isQuickDrawer.querySelector('.quantity-input');
  const currentQtyValue = currentQtyInput ? parseInt(currentQtyInput.value, 10) || 1 : 1;

  fetch(url)
    .then(res => res.text())
    .then(html => {
      const temp = document.createElement('div');
      temp.innerHTML = html;

      // ✅ Replace Quantity Selector (but don't reset value!)
      const newQtyBox = temp.querySelector('.quantity-selector');
      const oldQtyBox = isQuickDrawer.querySelector('.quantity-selector');
      if (newQtyBox && oldQtyBox) {
        oldQtyBox.innerHTML = newQtyBox.innerHTML;
      }

      // ✅ Restore previously selected quantity
      const restoredQtyInput = isQuickDrawer.querySelector('.quantity-input');
      if (restoredQtyInput) {
        restoredQtyInput.value = currentQtyValue;
        const hiddenQty = isQuickDrawer.querySelector('input[name="quantity"]');
        if (hiddenQty) hiddenQty.value = currentQtyValue;
      }

      // ✅ Replace Price Block
      const newPriceBlock = temp.querySelector('.component--product--price');
      const oldPriceBlock = isQuickDrawer.querySelector('.component--product--price');
      if (newPriceBlock && oldPriceBlock) {
        oldPriceBlock.innerHTML = newPriceBlock.innerHTML;
      }
      

      // ✅ Reinit quantity logic etc.
      runAllReinits(isQuickDrawer);
    })
    .catch(err => console.error('Quick Drawer variant update failed:', err));

  return; // 🚨 stop PDP logic from running
}



  if (!variant) {
    this._setSoldOutState();
    return;
  }

  if (this.idInput) this.idInput.value = variant.id;
  this._updateURL(variant.id);
  this._updateSelectedOptionTitles();
  this._renderPrices(variant);
  this._renderStickyBar(variant);
  this._maybeUpdateMedia(variant);
  showSpecificationsForVariant(variant);
  this.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant, options: this.options } }));
  document.dispatchEvent(new CustomEvent('pdp:variant', { detail: { variant, options: this.options } }));
  document.dispatchEvent(new CustomEvent('pdp:reinit'));
}


    _setSoldOutState() {
      // Disable ATC if no variant match
      if (this.form) {
        const btn = this.form.querySelector('[type="submit"], .component--product--form__button');
        if (btn) btn.disabled = true;
      }
      // Optional: show “Unavailable” / reset price
      if (this.priceSaleEl) this.priceSaleEl.textContent = '';
      if (this.stickyPriceEl) this.stickyPriceEl.textContent = '';
    }

    _moneyCentsToDisplay(cents) {
      if (typeof cents !== 'number') return '';
      const val = (cents / 100);
      return `$${val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} USD`;
    }

    _renderPrices(variant) {
      const hasCompare = !!variant.compare_at_price && variant.compare_at_price > variant.price;
      if (this.priceSaleEl)   this.priceSaleEl.textContent = this._moneyCentsToDisplay(variant.price);
      if (this.stickyPriceEl) this.stickyPriceEl.textContent = this._moneyCentsToDisplay(variant.price);

      if (this.priceBaseEl)   this.priceBaseEl.textContent = hasCompare ? this._moneyCentsToDisplay(variant.compare_at_price) : '';
      if (this.discountEl) {
        if (hasCompare) {
          const delta = variant.compare_at_price - variant.price;
          const pct   = Math.round(delta / variant.compare_at_price * 100);
          this.discountEl.textContent = `Save $${Math.round(delta / 100)} (${pct}%)`;
        } else {
          this.discountEl.textContent = '';
        }
      }

      // Also mirror to sticky compare if your sticky bar has one (optional)
      const stickyCompare = document.querySelector('.component--product--sticky-bar__compare');
      if (stickyCompare) {
        stickyCompare.textContent = hasCompare ? this._moneyCentsToDisplay(variant.compare_at_price) : '';
      }
    }

    _renderStickyBar(variant) {
      if (!this.stickyOptsBox) return;
      // Replace the two option chips (defensive if only 1 option)
      const chips = Array.from(this.stickyOptsBox.querySelectorAll('.component--product--sticky-bar--options'));
      const opts  = [variant.option1, variant.option2, variant.option3].filter(Boolean);
      chips.forEach((chip, idx) => {
        chip.textContent = opts[idx] ? (idx === 0 ? `${opts[idx]} -` : `${opts[idx]} `) : '';
      });

const stickyPCS = document.querySelector('.bottom_sticky_bar_pcs');
if (stickyPCS) {
  let pcsValue = 0;
  const variantTitle = (variant.title || '').toLowerCase().replace(/\s|-/g, '');

  if (variantTitle.includes('20oz')) {
    pcsValue = 600;
  } else if (variant.metafields?.custom?.quantity) {
    pcsValue = parseInt(variant.metafields.custom.quantity) || 0;
  } else {
    pcsValue = parseInt(stickyPCS.getAttribute('data-initial-pcs')) || 0;
  }

  stickyPCS.textContent = `${pcsValue.toLocaleString('en-US')} PCS`;
  stickyPCS.setAttribute('data-pcs', pcsValue);
}




    }

async _maybeUpdateMedia(variant) {
  if (!variant?.id) return;
 if (this.closest && this.closest('.qsm-quickshop-modal')) return;
  try {
    const url = `${this.productUrl}?variant=${variant.id}&section_id=${this.sectionId}`;
    const res = await fetch(url, { credentials: 'same-origin' });
    const html = await res.text();

    const temp = document.createElement('div');
    temp.innerHTML = html;

    // ✅ Replace product media
    const newMedia = temp.querySelector('product-media-slider');
    const oldMedia = document.querySelector('product-media-slider');
    if (newMedia && oldMedia) {
      oldMedia.innerHTML = newMedia.innerHTML;

      const splideEl = oldMedia.querySelector('.splide');
      if (splideEl) {
        if (splideEl.__splide) {
          try { splideEl.__splide.destroy(true); } catch(e) {}
        }
        new Splide(splideEl, {
          perPage: 1,
          pagination: true,
          arrows: true,
          gap: "0rem",
          breakpoints: { 768: { gap: "0rem", pagination: true } }
        }).mount();
      }
    }

    // ✅ Replace PDP main price block (component--product--price)
    const newMainPrice = temp.querySelector('.component--product--price');
    const oldMainPrice = document.querySelector('.component--product--price');
    if (newMainPrice && oldMainPrice) {
      oldMainPrice.innerHTML = newMainPrice.innerHTML;
    }

    // ✅ Replace Quantity Selector (the box with Case/PCS & price)
    const newQtyBox = temp.querySelector('.quantity-selector');
    const oldQtyBox = document.querySelector('.quantity-selector');
    if (newQtyBox && oldQtyBox) {
      oldQtyBox.innerHTML = newQtyBox.innerHTML;
    }

    // ✅ Replace Sticky Prices
const newSticky = temp.querySelector('.component--product--sticky-bar__prices');
const oldSticky = document.querySelector('.component--product--sticky-bar__prices');
if (newSticky && oldSticky) {
  oldSticky.innerHTML = newSticky.innerHTML;
}

// ✅ Replace Sticky Image
const newStickyImg = temp.querySelector('.component--product--sticky-bar__image-wrapper img');
const oldStickyImg = document.querySelector('.component--product--sticky-bar__image-wrapper img');
if (newStickyImg && oldStickyImg) {
  oldStickyImg.src = newStickyImg.src;
  oldStickyImg.srcset = newStickyImg.srcset;
  oldStickyImg.alt = newStickyImg.alt;
}


    firePdpUpdated();
    runAllReinits(document); // 👈 ye line add ki hai
  } catch (err) {
    console.error('Media/price update failed', err);
  }
}






    _updateSelectedOptionTitles() {
      const selected = this.options || [];
      this.optionTitleEls.forEach((el, i) => {
        el.textContent = selected[i] || '';
      });
    }

    _updateURL(variantId) {
      if (!history.replaceState) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variantId));
      history.replaceState({}, '', url.toString());
    }
  }

  customElements.define('variant-radios', VariantRadios);
})();





/* ============ SAFE HELPERS (shared) ============ */

function defineElementOnce(tagName, klass) {
  if (!customElements.get(tagName)) {
    customElements.define(tagName, klass);
  }
}

const $ = (sel, root = document) => root.querySelector(sel);
const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
function stripExecutableScripts(container) {
  $$('script:not([type="application/json"])', container).forEach(s => s.remove());
}

function firePdpUpdated() {
  document.dispatchEvent(new CustomEvent('pdp:updated'));
}

document.addEventListener("pdp:updated", () => {
  const mediaWrapper = document.querySelector(".component--product--media");
  const loader = mediaWrapper?.querySelector(".product-media-loader");
  if (!loader) return;

  loader.classList.remove("hidden"); // show loader while new media loads

  const mediaItems = mediaWrapper.querySelectorAll("img, video");
  let loadedCount = 0;

  const hideLoader = () => {
    loader.classList.add("hidden");
  };

  const markLoaded = () => {
    loadedCount++;
    if (loadedCount >= mediaItems.length) hideLoader();
  };

  mediaItems.forEach((item) => {
    if (item.tagName === "VIDEO") {
      if (item.readyState >= 3) markLoaded();
      else item.addEventListener("loadeddata", markLoaded, { once: true });
    } else {
      if (item.complete && item.naturalWidth > 0) markLoaded();
      else {
        item.addEventListener("load", markLoaded, { once: true });
        item.addEventListener("error", markLoaded, { once: true });
      }
    }
  });

  // Fallback — hide after 5s if lazy load misbehaves
  setTimeout(hideLoader, 5000);
});


/* ============ SPLIDE (idempotent) ============ */

function mountStrawSlider() {
  const el = document.querySelector('.component--product--straw-selector__list_slider');
  if (!el || typeof Splide === 'undefined') return;

  // Destroy old instance if exists
  if (el.__splide) {
    try { el.__splide.destroy(true); } catch(e) {}
    el.__splide = null;
  }

  // Reorder slides
  const splideList = el.querySelector('.splide__list');
  if (splideList) {
    const slides = Array.from(splideList.children);

    // Sort by data-sequence
    slides.sort((a, b) => a.dataset.sequence - b.dataset.sequence);

    // Move active slide to front
    const activeSlide = slides.find(slide =>
      slide.classList.contains('component--product--straw-selector__item--active')
    );

    if (activeSlide) {
      slides.splice(slides.indexOf(activeSlide), 1);
      slides.unshift(activeSlide);
    }

    // Replace with reordered slides
    splideList.innerHTML = '';
    slides.forEach(slide => splideList.appendChild(slide));
  }

  // Init Splide
  el.__splide = new Splide(el, {
    type       : 'slide',
    perPage    : 1.5,
    perMove    : 1,
    pagination : true,
    focus      : 'left',
    arrows     : true,
    gap        : '8px',
    flickPower : 150,
    flickMaxPages: 1,
    easing     : 'ease-in-out',
    drag       : true,
    rewind     : false,
    mediaQuery : 'min',
    breakpoints: {
      768: { perPage: 2.1, arrows: true, pagination: false }
    }
  });

  try { el.__splide.mount(); } catch(e) {}
}


document.addEventListener('DOMContentLoaded', mountStrawSlider);
document.addEventListener('pdp:updated', mountStrawSlider);



/* ============ VARIANT INPUTS: global delegation (no duplicate listeners) ============ */

document.addEventListener('change', (e) => {
  const input = e.target;
  if (!input.matches('.component--product--variant-radio__input')) return;

  // ✅ Stop if this variant change is happening inside Quick Drawer
  if (input.closest('.qsm-quickshop-modal')) return;

  const host = input.closest('variant-radios');
  if (host && typeof host.onVariantChange === 'function') {
    host.onVariantChange();
  }
});



/* ===== Variant URL manager (idempotent) ===== */
(function () {
  if (window.__variantUrlManagerReady) return;
  window.__variantUrlManagerReady = true;

  // ---- Helpers ----
  function getVariantRoot(el) {
    return el?.closest?.('variant-radios') || document.querySelector('variant-radios');
  }

  function getVariantsJSON(radiosRoot) {
    try {
      const script = (radiosRoot || document).querySelector('script[type="application/json"]');
      if (!script) return null;
      return JSON.parse(script.textContent.trim());
    } catch (e) {
      console.warn('[VariantURL] Failed to parse variants JSON', e);
      return null;
    }
  }

  function getSelectedOptions(radiosRoot) {
    const checked = Array.from((radiosRoot || document).querySelectorAll('.component--product--variant-radio__input:checked'));
    return checked.map((i) => i.value);
  }

  function findSelectedVariant(variants, selectedOptions) {
    if (!Array.isArray(variants) || !Array.isArray(selectedOptions)) return null;
    return variants.find(v => Array.isArray(v.options) && v.options.length === selectedOptions.length &&
      v.options.every((opt, idx) => opt === selectedOptions[idx]));
  }

  function getCleanProductPath(radiosRoot) {
    // Prefer the product path Shopify put on <variant-radios data-url="/products/handle">
    const dataUrl = getVariantRoot(radiosRoot)?.dataset?.url;
    if (dataUrl && /^\/products\//.test(dataUrl)) return dataUrl;
    // fallback to current path
    return window.location.pathname.replace(/\/+$/, '');
  }

  function replaceUrlWithVariant(variantId, radiosRoot) {
    const path = getCleanProductPath(radiosRoot);
    const url = new URL(window.location.origin + path);
    if (variantId) url.searchParams.set('variant', String(variantId));
    // If you also have other query params you care about, copy them from current URL here
    history.replaceState({}, '', url.pathname + url.search);
    console.log('url_replaced');
  }

function stripVariantFromUrlOnce() {
  try {
    if (window.__variantParamStripped) return;
    const url = new URL(window.location.href);
    if (url.searchParams.has('variant')) {
      url.searchParams.delete('variant');
      history.replaceState({}, '', url.pathname + (url.search ? '?' + url.search : ''));
    }
    window.__variantParamStripped = true;
  } catch (e) {}
}
document.addEventListener('DOMContentLoaded', stripVariantFromUrlOnce);



  // ---- 2) When user changes a variant: add ?variant=id ----
  // Works regardless of how your theme wires change (native change, delegated, or custom events)
  function handleVariantChange(e) {
    // Only react to variant radios (your class names)
const update_qty = window.AppState?.selectedQuantity ?? 1;
      console.log('variant change now',update_qty);
           const quantityInputForm = document.querySelector('.component--product--form__wrapper input[name="quantity"]');
     console.log('quantity set check');
           setTimeout(() => {
        const qtyInput = document.querySelector('input.input_quick_shop_form[name="quantity"]');
  if (qtyInput) {
  qtyInput.value = update_qty;
  AppState.selectedQuantity = 1;
  console.log('Set quantity input value to:', update_qty);
} else {
  quantityInputForm.value = 1;
  console.warn('Quantity input not found');
}
      }, 1000);
    const target = e?.target;
    if (!target || !target.matches('.component--product--variant-radio__input')) return;

      // ✅ Stop if variant change happens inside Quick Drawer
  if (target.closest('.qsm-quickshop-modal')) return;
    const radiosRoot = getVariantRoot(target);
    const variants = getVariantsJSON(radiosRoot);
    if (!variants) return;

    const selectedOptions = getSelectedOptions(radiosRoot);
    const selectedVariant = findSelectedVariant(variants, selectedOptions);
    if (!selectedVariant || !selectedVariant.id) return;
    replaceUrlWithVariant(selectedVariant.id, radiosRoot);
  }

  // Delegate listener once
  document.addEventListener('change', handleVariantChange, true);
  document.addEventListener('variant:changed', function (e) {
    // Expecting e.detail = { variant, root }
    const variant = e?.detail?.variant;
    const root = e?.detail?.root || null;
    if (variant && variant.id) {
      replaceUrlWithVariant(variant.id, root);
    }
  });


// ✅ GLOBAL PCS FORMATTER FOR PDP + CART DRAWER (AUTO RECONNECTING)
(function () {
  function formatPCSWithCommas() {
    document.querySelectorAll('.quantity_span_total_pieces').forEach(el => {
      const text = el.textContent.trim();
      const match = text.match(/([\d,]+)/);
      if (match) {
        const num = parseInt(match[1].replace(/,/g, ''), 10);
        if (!isNaN(num)) el.textContent = `${num.toLocaleString('en-US')} PCS`;
      }
    });
    document.querySelectorAll('.component--cart-drawer--line-item__subtitle').forEach(el => {
      const text = el.textContent.trim();
      const match = text.match(/^PCS:\s*(\d+)$/);
      if (match) {
        const num = parseInt(match[1], 10);
        if (!isNaN(num)) el.textContent = `PCS: ${num.toLocaleString('en-US')}`;
      }
    });
  }

  function attachObserver() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return setTimeout(attachObserver, 500);
    const observer = new MutationObserver(() => requestAnimationFrame(formatPCSWithCommas));
    observer.observe(drawer, { childList: true, subtree: true });
  }

  ['DOMContentLoaded', 'shopify:section:load', 'cart:updated', 'pdp:updated'].forEach(evt =>
    document.addEventListener(evt, () => setTimeout(formatPCSWithCommas, 100))
  );

  attachObserver();

  // ✅ Expose globally (so you can call it manually if needed)
  window.formatPCSWithCommas = formatPCSWithCommas;
})();




})();
